(function() {
  "use strict";

  angular
    .module("app")
    .controller("RaceEthnoChartsController", [
      "$scope",
      "$sanitize",
      "$timeout",
      "$location",
      "rankingsService",
      RaceEthnoChartsController,
    ]);

  function RaceEthnoChartsController(
    $scope,
    $sanitize,
    $timeout,
    $location,
    rankingsService,
  ) {
    $scope.showHoverStats = [];
    $scope.state.communityCharts = {};
    $scope.state.selectedChartCommunities = [];

    var madeChartSelection = false;

    $scope.getFirstDemographic = function(demographics) {
      var key = demographics ? Object.keys(demographics)[0] : null;

      return key ? demographics[key] : [];
    };

    $scope.rebuildCharts = function(forceReload) {
      if (!$scope.state.chartsToShow && !$scope.state.communitiesByRank) {
        return;
      }

      var rebuild = function(forceReload) {
        var demographicsIndicatorKey = $scope.state.citywideStats
          ? Object.keys($scope.state.citywideStats)[0]
          : undefined;

        if (demographicsIndicatorKey) {
          if (!$scope.state.communityCharts.all) {
            var thisChart = chartDefaults;
            thisChart.data.datasets[0].data = [];

            var remainder = 1;

            $scope.state.citywideStats[demographicsIndicatorKey].forEach(
              function(demo, ind, arr) {
                // data arrives as floating point
                thisChart.data.datasets[0].data.push(demo.percent);
                $scope.chartLegend[ind].label = demo.name;
                remainder = remainder - demo.percent;
              },
            );

            if (remainder > 0) {
              thisChart.data.datasets[0].data.push(remainder);
              $scope.chartLegend[$scope.chartLegend.length - 1].label = "Other";
              $scope.state.citywideStats[demographicsIndicatorKey].push({
                name: "Other",
                percent: remainder,
                display: Math.round(remainder * 1000) / 10 + "%",
              });
            }

            $scope.state.communityCharts.all = new Chart(
              document.getElementById("race-ethno-chart-all").getContext("2d"),
              thisChart,
            );
          }
          else {
          }

          $scope.state.chartsToShow.forEach(function(comm, ind, arr) {
            var thisChart = chartDefaults;
            thisChart.data.datasets[0].data = [];

            if (comm.demographics) {
              var remainder = 1;
              comm.demographics[demographicsIndicatorKey].forEach(function(
                demo,
                ind,
                arr,
              ) {
                // data arrives as floating point
                thisChart.data.datasets[0].data.push(demo.percent);
                $scope.chartLegend[ind].label = demo.name;
                remainder = remainder - demo.percent;
              });

              if (remainder > Number.EPSILON) {
                thisChart.data.datasets[0].data.push(remainder);
                $scope.chartLegend[$scope.chartLegend.length - 1].label =
                  "Other";
                
                if(!comm.demographics[demographicsIndicatorKey].some((demographic) => demographic && demographic.name === "Other")) {
                  // Only add a catch-all "Other" demographic if there isn't one with that name yet
                  comm.demographics[demographicsIndicatorKey].push({
                    name: "Other",
                    percent: remainder,
                    display: Math.round(remainder * 1000) / 10 + "%",
                  });
                }
              }

              if (!$scope.state.communityCharts[comm.id]) {
                $scope.state.communityCharts[comm.id] = new Chart(
                  document
                    .getElementById("race-ethno-chart-" + ind)
                    .getContext("2d"),
                  thisChart,
                );
              }

              if (forceReload) {
                $scope.state.communityCharts[comm.id].update();
              }
            }
          });
        }
      };

      $timeout(function() {
        rebuild(forceReload);
      }, 150);
    };

    $scope.$watch(
      "state.communitiesByRank",
      function() {
        if (!$scope.state.communitiesByRank) return;

        if (!madeChartSelection) {
          $scope.state.communityCharts = {};

          if ($location.search()["charts"]) {
            madeChartSelection = true;
            var commIds = $location
              .search()
              ["charts"].split(",")
              .map(function(id) {
                return +id;
              });
            $scope.state.selectedChartCommunities = commIds;
            $scope.state.chartsToShow = commIds.map(function(id) {
              return $scope.state.communitiesById[id];
            });
          }
          else {
            $scope.state.chartsToShow = rankingsService
              .lowestRanked($scope.state.communitiesByRank)
              .concat(
                rankingsService.highestRanked($scope.state.communitiesByRank),
              );
          }
        }
      },
      true,
    );

    $scope.$watch(
      "state.chartsToShow",
      function() {
        $scope.rebuildCharts(true);
      },
      true,
    );

    $scope.chartLegend = [
      {
        color: "#516747",
      },
      {
        color: "#648c4e",
      },
      {
        color: "#64ab4d",
      },
      {
        color: "#b9d5aa",
      },
      {
        color: "#ededed",
      },
    ];

    var chartDefaults = {
      type: "pie",
      data: {
        labels: ["Red", "Blue", "Yellow"],
        datasets: [
          {
            data: [300, 50, 100, 20],
            backgroundColor: ["#516747", "#648c4e", "#64ab4d", "#b9d5aa"],
          },
        ],
      },
      options: {
        tooltips: {
          enabled: false,
        },
        legend: {
          display: false,
        },
        responsive: false,
      },
    };

    // TODO - This is copied from the main Typeahead component
    // No time to refactor Typeahead, do that soon.

    $scope.state.toggleChartCommunity = function(id) {
      var selectedCharts = $scope.state.selectedChartCommunities;

      if (!madeChartSelection) {
        madeChartSelection = true;
        selectedCharts = rankingsService
          .lowestRanked($scope.state.communitiesByRank)
          .concat(rankingsService.highestRanked($scope.state.communitiesByRank))
          .map(function(x) {
            return x.id;
          });
      }

      var index = selectedCharts.indexOf(id);
      if (index >= 0) {
        selectedCharts.splice(index, 1);
        $scope.state.communityCharts[id] = undefined;

        // Tracks when a user removes a community
        dataLayer.push({
          event: "Community Removed",
          eventCategory: "Interactive Clicks",
          eventAction:
            "Community Removed|" + $scope.state.communitiesById[id].name,
          eventLabel: window.location.pathname,
        });
      }
      else {
        selectedCharts.push(id);
      }

      $location.search("charts", selectedCharts.join(","));
      $scope.state.selectedChartCommunities = selectedCharts;
      $scope.state.chartsToShow = $scope.state.selectedChartCommunities.map(
        function(id) {
          return $scope.state.communitiesById[id];
        },
      );
    };

    $scope.chartTypeahead = {};

    $scope.chartResetTypeahead = function() {
      // Prevents first item from being selected automatically
      $scope.chartTypeahead.selectedIndex = -1;

      $scope.chartTypeahead.filteredResults = [];

      // Empty out typeahead input field
      $scope.chartQueryString = "";
    };

    $scope.chartResetTypeahead();

    $scope.chartUpdateTypeahead = function(needle) {
      $scope.chartTypeahead.filteredResults = $scope.state.communityData.filter(
        function(community) {
          return firstLettersFilter(community.name, needle);
        },
      );
    };

    // Typeahead filter
    // Requirements: find matches for community names where any word starts with a user-provided
    // string. Example: `b` matches `Battery Park` and `Midtown Business District`
    // TODO - This should probably be its own filter file
    function firstLettersFilter(haystack, needle) {
      // Split the community name by any non-word characters
      var parsedStr = haystack.toLowerCase().split(/\W+/);

      // User input and strings to search are converted to lowercase
      needle = needle.toLowerCase();

      for (var i = 0; i < parsedStr.length; i++) {
        if (parsedStr[i].indexOf(needle) === 0) {
          // string match found!
          return true;
        }
      }

      // no string match found
      return false;
    }

    $scope.chartTypeaheadKeyPressed = function(event, communityId) {
      if (event.key === "ArrowDown") {
        $scope.chartTypeahead.selectedIndex += 1;
      }
      else if (event.key === "ArrowUp") {
        $scope.chartTypeahead.selectedIndex =
          $scope.chartTypeahead.selectedIndex >= -1
            ? $scope.chartTypeahead.selectedIndex - 1
            : -1;
      }
      else if (event.key === "Enter") {
        var selectedId =
          $scope.chartTypeahead.filteredResults[
            $scope.chartTypeahead.selectedIndex
          ].id;
        $scope.chartTypeaheadSelected(selectedId);
      }
      else {
        // If the keypress isn't an arrow, it's probably a letter or number
        // Reset the selected index
        $scope.chartTypeahead.selectedIndex = -1;
      }
    };

    $scope.chartTypeaheadSelected = function(id) {
      // Tracks when a user searches using "Add community to compare" which displays a race/ethnicity pie chart on the "Risk Ranking" page
      dataLayer.push({
        event: "Compare Community for Race/Ethnicity",
        eventCategory: "Interactive Clicks",
        eventAction:
          "RE Community Search|" + $scope.state.communitiesById[id].name,
        eventLabel: window.location.pathname,
      });

      $scope.state.toggleChartCommunity(id);
      $scope.chartResetTypeahead();
    };
  }
})();
